import {SelectOption } from '../types/candidate.types';

export const GENDER_OPTIONS: SelectOption[] = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' }
];

export const MARITAL_STATUS_OPTIONS: SelectOption[] = [
  { value: 'single', label: 'Single' },
  { value: 'married', label: 'Married' }
];

export const TYPE_OPTIONS: SelectOption[] = [
  { value: 'intern', label: 'Intern' },
  { value: 'probation', label: 'Probation' }
];

export const normalizeEmploymentType = (value?: string): string => {
  const normalized = (value || '').trim().toLowerCase();
  const match = TYPE_OPTIONS.find((option) => option.value === normalized);
  return match?.value || '';
};
